// design/NoAccess.dc.html's "gone" variant — the only one of the three that doesn't leak
// whether the thing ever existed. §4.10/AC3: the API returns 404 for both "no such grackle"
// and "you can't see this grackle" (denial is always ApiError::NotFound), so the UI must show
// the identical page for both cases too — anything more specific ("you don't have access")
// would itself leak existence. Used for the router's catch-all "*" route AND wherever
// WatchPage/SharePage get a 404 from GET /watch or GET /share.
import { Link } from "react-router-dom";
import { NoAccessShell } from "../components/NoAccessShell";
import { SWITCH_ORG_PATH } from "../lib/lastOrg";

export default function NotFound() {
  return (
    <NoAccessShell icon="warning-circle" title="This recording is not here">
      <p>
        The link may be wrong, or the recording was deleted. We can't tell you which — that would leak whether it ever
        existed.
      </p>
      <p>
        If someone sent you this link, ask them to check it. Signed in with the wrong account?{" "}
        <Link to={SWITCH_ORG_PATH}>Switch organizations</Link> and try again.
      </p>
    </NoAccessShell>
  );
}
